/**
 * Creates Html Script element with specified src
 * @param src - specifies the URI of an external script
 * @param async - script will be fetched in parallel to parsing and evaluated as soon as it is available
 * @param defer - is set to indicate to a browser that the script is meant to be executed after the document has been parsed
 * @param onLoad - The load event fires when a given resource has loaded.
 * @param onError - The error event fires when some form of error occurs while attempting to load or perform the media.
 */
export const createScript = (
	src: string,
	async = false,
	defer = false,
	onLoad = () => {},
	onError: OnErrorEventHandlerNonNull = () => {}
): HTMLScriptElement => {
	const script = document.createElement(`script`)

	script.src = src
	script.async = async
	script.defer = defer
	script.onload = onLoad
	script.onerror = onError

	return script
}
